import {
  actionDescriptionLocoKeys,
  actionTitleLocoKeys,
} from 'modules/automation-rules/actions/constants/action-loco-keys'
import { AutomationRuleActionsEnum } from 'modules/automation-rules/actions/enums/action-enum'
import {
  ActionsDataInterface,
  useActionsData,
} from 'modules/automation-rules/actions/hooks/use-actions-data'
import { getActionDataFromSlug } from 'modules/automation-rules/actions/utils/get-action-data-from-slug'
import { getActionIcon } from 'modules/automation-rules/actions/utils/get-action-icon'
import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { CloseIcon } from '@systemeio/ui/icons'

export interface WrapperChildrenPropsInterface {
  renderActionLabel: ({
    label,
    additionalLabel,
  }: {
    label: string
    additionalLabel?: JSX.Element
  }) => JSX.Element
  onOpen: () => void
  data: ActionsDataInterface
}
type ChildrenType = (args: WrapperChildrenPropsInterface) => JSX.Element

interface EditActionWrapperProps {
  slug: AutomationRuleActionsEnum
  children: ChildrenType
  onDelete: () => void
}

const EditActionWrapper = ({ slug, children, onDelete }: EditActionWrapperProps) => {
  const { t } = useLocoTranslation()

  const { data, setShouldFetch } = useActionsData()
  const renderActionLabel = ({
    label,
    additionalLabel,
  }: {
    label: string
    additionalLabel?: JSX.Element
  }) => (
    <div className={'flex justify-between gap-1.5'}>
      <div className="flex gap-0.5 text-sm font-medium">
        <span>{label}</span>
        <span className="text-danger">*</span>
      </div>
      <div className={'flex items-center gap-1.5'}>{additionalLabel}</div>
    </div>
  )

  const childrenData = {
    renderActionLabel,
    onOpen: () => setShouldFetch(prev => ({ ...prev, [getActionDataFromSlug(slug)]: true })),
    data,
  }

  return (
    <div className={`flex flex-col gap-3`}>
      <div className={'flex justify-between gap-3'}>
        <div className={'flex gap-3'}>
          <div className={'[&>svg]:h-[40x] [&>svg]:w-[40px] w-[40px]'}>{getActionIcon(slug)}</div>
          <div className={'flex flex-col gap-1'}>
            <span className={'text-text-primary text-[15px] font-bold'}>
              {t(actionTitleLocoKeys[slug])}
            </span>
            <span>{t(actionDescriptionLocoKeys[slug])}</span>
          </div>
        </div>
        <button onClick={onDelete} className={`group h-fit outline-hidden`}>
          <CloseIcon
            className={
              'main-transition-colors fill-fill-primary group-hover:fill-text-primary group-focus-visible:fill-text-primary'
            }
          />
        </button>
      </div>
      {children(childrenData)}
    </div>
  )
}

export default EditActionWrapper
